import type { Auth0ContextInterface, User } from '@auth0/auth0-react';
import axios from 'axios';
import { baseURL } from '../utils/baseUrls';
import * as Sentry from '@sentry/react';

export class SigmaJwtClient {
  constructor(private readonly auth0: Auth0ContextInterface<User>) {}

  getToken = async () => {
    const { getAccessTokenSilently } = this.auth0;
    return getAccessTokenSilently();
  };

  generateSigmaJwt = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/api/v1/generate-sigma-jwt`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (err) {
      console.error(err);
      Sentry.captureException(err);
      throw err;
    }
  };
}
